import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { countryChannelSave } from '@/api/yuntuSales/operationsManage'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'


const __default__ = { name: 'CountryChannelModal' }

interface CountryChannelParams {
  paramId: number
  paramRefIdList: number[]
}
interface ParamCodeFormatItem extends ParamCodeItem {
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    paramCodeData: {}
  },
  emits: ['fetch'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const title = ref<string>()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { paramId: -9, paramRefIdList: [] }
const dataForm = ref<CountryChannelParams>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  paramId: [{ required: true, validator: selectForNumberValidate, message: '请选择国家' }],
  paramRefIdList: [{ required: true, message: '请选择云途产品' }]
}

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const paramCodeFormat = ref<{ [key: string]: ParamCodeFormatItem[] }>({})
const init = (countryList: number[], data: any) => {
  paramCodeFormat.value = cloneDeep(props.paramCodeData)
  if (data) {
    title.value = '编辑'
    dataForm.value.paramId = data.paramId
    dataForm.value.paramRefIdList = data.paramRefIdList
    const find = countryList.findIndex((item) => item === data.paramId)
    find && countryList.splice(find, 1)
  } else {
    title.value = '新增'
  }
  paramCodeFormat.value.lbu_demand_country.forEach((item) => {
    item.disabled = countryList.includes(item.id as number)
  })
  visible.value = true
}

const emit = __emit
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    countryChannelSave(params)
      .then(() => {
        DcMessage.success(`${title.value}成功`)
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: title.value,
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: dataForm.value,
        ref_key: "formRef",
        ref: formRef,
        rules: formRules,
        "wrapper-col": { span: 24 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            name: "paramId",
            label: "国家",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.paramId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.paramId) = $event)),
                options: paramCodeFormat.value.lbu_demand_country,
                placeholder: "请选择国家",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            name: "paramRefIdList",
            label: "云途产品",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(ParamCodeCascader, {
                value: dataForm.value.paramRefIdList,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.paramRefIdList) = $event)),
                options: paramCodeFormat.value.lbu_products,
                placeholder: "请选择云途产品",
                multiple: "",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirm-loading"]))
}
}

})